module.exports = __webpack_public_path__ + "ke.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ke.svg
// module id = 886
// module chunks = 0